import { IPwaPushApiResult, IPwaPushApiRow, PwaPushSyncStatus } from '../types';

export function parsePwaPushResponse(payload: unknown, successStatus: PwaPushSyncStatus): IPwaPushApiResult {
    if (!Array.isArray(payload) || payload.length === 0) {
        return { status: 'error', note: 'EmptyResponse' };
    }

    const row = payload[0] as IPwaPushApiRow;
    const note = typeof row.Note === 'string' ? row.Note : undefined;

    if (note === 'Success') {
        return { status: successStatus, note };
    }

    return { status: 'error', note: note || 'Unknown' };
}
